<template>
	<template v-if="options.events">
		<FullCalendar
			:options="options"
			/>
	</template>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import allLocales from '@fullcalendar/core/locales-all';

// import { wrapperToggleUpdate } from '@vueapp/lib/common'

export default {
	name: 'CalendarComponent',
	props: {
		templateData: {
			type: Object,
			default: {},
			required: true
		}
	},
	components: {
		FullCalendar
	},
	data() {
		return {
			options: {
                plugins: [
                    dayGridPlugin,
                    interactionPlugin,
                    timeGridPlugin,
                    listPlugin
                ],
                locale:  this.getLocalization(),
                initialView: 'dayGridMonth',
                dateClick: this.handleDateClick,
                eventClick: this.handleEventClick,
                datesSet: this.handleMonthChange,
                events: null,
                customButtons: {},
                initialDate: this.getInitialDate(),
                headerToolbar: {
                    // left: 'prev,next today myCustomButton, timeGridWeek,timeGridDay',
                    // center: 'title',
                    right: 'today prev,next'
                }
            },

		}
	},

	created() {
		this.options.events = JSON.parse( this.templateData.calendar_json ) ?? []
        this.generateCustomButtons();
	},

	methods: {
        generateCustomButtons: function(){
        const that = this;
            const topActionButtons = this.templateData.top_action_buttons.top_action_buttons || [];

            topActionButtons.forEach((button, index) => {
                const buttonKey = `customButton${index + 1}`;

                this.options.headerToolbar.right = this.options.headerToolbar.right + ` customButton${index + 1}`
                this.options.customButtons[buttonKey] = {
                    text: (button.icon && button.icon === 'plus') ? `+ ${button.button_text}` : button.button_text,
                    click: function() {
                        window.location.href = button.iframe_src;
                    }
                }
            })

            if(this.vw) {
                this.options.headerToolbar.right = this.options.headerToolbar.right + ` dataView boardView calendarView`
                this.options.customButtons.dataView = {
                    icon: 'dataview',
                    click: function() {
                        // that.simulateClick(document.querySelector('a[data-target="#vw-component--data-view"]'));
                        // wrapperToggleUpdate({target:'vw-component--data-view'})
                        that.emitter.emit('wrapper-toggle-update', { target: 'data-view' })
                    }
                }

                this.options.customButtons.boardView = {
                    icon: 'board',
                    click: function() {
                        // that.simulateClick(document.querySelector('a[data-target="#vw-component--board"]'));
                        // wrapperToggleUpdate({target:'vw-component--board'})
                        that.emitter.emit('wrapper-toggle-update', { target: 'board' })
                    }
                }

                this.options.customButtons.calendarView = {
                    icon: 'calendar',
                }
            }
        },
        simulateClick: function(el) {
            // Create our event (with options)
            var evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            // If cancelled, don't dispatch our event
            var canceled = !el.dispatchEvent(evt);
        },
		getLocalization: function() {
            // console.log(window.calendar_locale)
            return window.calendar_locale ?? 'en'
        },
        getInitialDate: function (){
            const urlParams = new URLSearchParams(window.location.search);
            let calendarDate = urlParams.get('calendarDate')

            if(!calendarDate) {
                const dateObject = new Date();
                const year = dateObject.getFullYear();
                const month = (dateObject.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
                const day = dateObject.getDate().toString().padStart(2, "0");
                calendarDate = `${year}-${month}-${day}`
                urlParams.set('calendarDate', calendarDate)
            }

            return calendarDate;
        },
        handleMonthChange: function(payload) {
            const dateObject = new Date(payload.view.getCurrentData().currentDate);
            const year = dateObject.getFullYear();
            const month = (dateObject.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
            const day = dateObject.getDate().toString().padStart(2, "0");

            const formattedDate = `${year}-${month}-${day}`;

            const url = new URL(window.location.href);
            url.searchParams.set('calendarDate', formattedDate);

            window.history.replaceState(null, null, url); // or pushState

            if ( document.getElementById('calendar-month') ) {
                document.getElementById('calendar-month').innerHTML = document.getElementsByClassName('fc-toolbar-title')[0].innerHTML
            }
        },
        handleEventClick: function(info) {
            var obj = info.event.extendedProps;

            // console.log('obj::', info.jsEvent.clientY)

            var popover_offset_h = info.jsEvent.clientY + 12 - info.el.closest('.fc-daygrid-day-frame').getBoundingClientRect().top - info.el.closest('.fc-daygrid-day-frame').getBoundingClientRect().height
            let topCalculation =  `top: calc(100% + ${popover_offset_h}px)`;

            if((window.innerHeight - 300) < info.jsEvent.clientY) {
                popover_offset_h =  (info.jsEvent.clientY - info.el.closest('.fc-daygrid-day-frame').getBoundingClientRect().top - info.el.getBoundingClientRect().height) < 20 ? 20 : info.jsEvent.clientY + 24 - info.el.closest('.fc-daygrid-day-frame').getBoundingClientRect().top - info.el.getBoundingClientRect().height

                topCalculation =  `bottom: calc(100% - ${popover_offset_h}px)`;
            }

            let closeToRight = window.innerWidth - info.jsEvent.clientX < 350
            let closeToBottom = window.innerHeight - info.jsEvent.clientY < 350

            if(document.querySelector('.bryter-calendar-popover')) {
                document.querySelector('.bryter-calendar-popover').remove();
            }



            function contentAreaItem(item) {
                if(item.name !== 'action') {
                    return `<div>
                                        <div class="caption-uppercase color-gray">${item.name}</div>
                                        <div>${item.value}</div>
                                    </div>`;
                }
            }

            function actionButton(item) {
                let buttons = []
                // console.log(item.value, item.value)
                if(item.name === 'action' && item.value && item.value.length) {
                    // console.log('actionButton', item.value)
                    for (let btn of item.value) {
                        buttons.push(`<a href="${btn.url}" class="Btn Btn--small margin-right-4">${ 'text-button' == btn.button_type ? btn.button_text : 'icon-button' == btn.button_type ? '<span class="' + btn.button_icon + '"></span>' : '' }</a>`)
                    }
                }
                return buttons.length ? `<div class="Popover__footer">${buttons.join('')}</div>` : ''

            }


            // console.log('popover_offset_h::', Math(popover_offset_h)
            var popover = `<div class="Popover bryter-calendar-popover ${ closeToRight ? 'close-to-right': ''} ${ closeToBottom ? 'close-to-bottom': ''}" style="${topCalculation}" data-clickable="${ obj.clickable_el !== false ? 'true' : 'false' }" data-clickable-url="${ obj.clickable_el ? obj.clickable_el.url : '' }">
                                        <div class="Popover__header">
                                            <h4 class="title-5">${obj.heading}</h4>
                                            <button type="button" class="Btn-icon Btn-icon--tiny" onclick="$('.bryter-calendar-popover').remove()">
                                                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" 	xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2589 2.66669L7.99984 6.9265L3.74079 2.66669L2.6665 3.74097L6.92555 8.00002L2.6665 12.2591L3.74079 13.3334L7.99984 9.07431L12.2589 13.3334L13.3332 12.2591L9.07412 8.00002L13.3332 3.74097L12.2589 2.66669Z" />
                                                </svg>
                                            </button>
                                        </div>

                                        <div class="Popover__section Stack Stack--small">
                                            ${Object.values(obj.props).map(contentAreaItem).join("")}
                                        </div>

                                        ${Object.values(obj.props).map(actionButton).join("")}
                                    </div>`;
            // info.el.insertAdjacentHTML('afterend', popover);
            info.el.closest('.fc-daygrid-day-frame').insertAdjacentHTML('afterend', popover);
        }
	},

	computed: {
        vw() {
            if ( this.wrapperView ) return true;
        }
	},

    inject: {
        wrapperView: {
            from: 'wrapperView',
            default: false
        }
    },
}
</script>

<style>
.fc .fc-button-primary {
    display: inline-flex;
    align-items: center;
    padding: 0 16px;
    height: 40px;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    border: 1px solid var(--fe-theme-primary-color);
    border-radius: 2px;
    appearance: none;
    color: #ffffff;
    background-color: var(--fe-theme-primary-color);
    position: relative;
    &:after {
        content: '';
        position: absolute;
        inset: -1px;
        z-index: 1;
    }
}

.fc .fc-button-primary:not(.fc-dataView-button):not(.fc-boardView-button):not(.fc-calendarView-button):hover {
    background-color: var(--fe-theme-primary-color);
    border-color: var(--fe-theme-primary-color);
}

.fc .fc-button-primary:not(.fc-dataView-button):not(.fc-boardView-button):not(.fc-calendarView-button):hover:after,
.fc .fc-button-primary:not(.fc-dataView-button):not(.fc-boardView-button):not(.fc-calendarView-button):focus:after {
    background: var(--fc-event-selected-overlay-color);
}

</style>